import React from 'react';
import BlogPosta from './blogs/bloga';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


const Blogs: React.FC = () => {
    return (

        <div className="container">
            <div className="row mb-4">
                <div className="col-12">
                    <div className="d-flex align-items-start gap-4">
                        <div className="flex-shrink-0">
                            <img src="/images/bloga.webp" alt="Don't Wait for Tomorrow: Your Financial Dreams Need Action Today!" className="img-fluid rounded blog-image" />
                        </div>
                        <div className="flex-grow-1">
                            <header className="mb-3">
                                <h1 className="h2 text-start">Don't Wait for Tomorrow: Your Financial Dreams Need Action Today!</h1>

                                <div className="text-muted">
                                    <span className="me-3">Published on: </span>
                                    <span>2024-01-15</span>
                                </div>
                            </header>
                            <div className="blog-content"></div>
                            <p className="lead">Don’t wait for the “perfect” time—start building your financial future today. The power of compounding, rising inflation, and life’s surprises mean starting small now beats waiting. Define your goals, kick off a simple SIP, and adjust along the way.</p>
                            <Link to="/blogs/firstblog">Read more →</Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row mb-4" style={{ minHeight: '200px' }}>
                <div className="col-md-4" style={{ minWidth: '200px' }}>
                    <div className="d-flex align-items-start gap-4">
                        <div>
                            <div className="flex-shrink-0">
                                <img src="/blog1.webp" alt="Getting Started with TypeScript" className="img-fluid rounded" style={{ width: '400px', height: '200px', objectFit: 'cover' }} />
                            </div>
                            <div className="flex-grow-1">
                                <header className="mb-3">
                                    <h1 className="h2 text-start">Getting Started with TypeScript</h1>

                                    <div className="text-muted">
                                        <span className="me-3">Pubished on: </span>
                                        <span>2024-01-15</span>
                                    </div>
                                </header>
                                <div className="blog-content"></div>
                                <p className="lead">TypeScript is a powerful superset of JavaScript that adds static typing...asdkjsdafasdfads TypeScript is a powerful superset of JavaScript that adds static typing...asdkjsdafasdfads</p>
                                <Link to="/blogs/firstblog">Read more →</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4" style={{ minWidth: '200px' }}>
                    <div>
                        <div className="flex-shrink-0">
                            <img src="/blog1.webp" alt="Getting Started with TypeScript" className="img-fluid rounded" style={{ width: '400px', height: '200px', objectFit: 'cover' }} />
                        </div>
                        <div className="flex-grow-1">
                            <header className="mb-3">
                                <h1 className="h2 text-start">Getting Started with TypeScript</h1>

                                <div className="text-muted">
                                    <span className="me-3">Pubished on: </span>
                                    <span>2024-01-15</span>
                                </div>
                            </header>
                            <div className="blog-content"></div>
                            <p className="lead">TypeScript is a powerful superset of JavaScript that adds static typing...asdkjsdafasdfads TypeScript is a powerful superset of JavaScript that adds static typing...asdkjsdafasdfads</p>
                            <Link to="/blogs/firstblog">Read more →</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-4" style={{ minWidth: '200px' }}>
                    <div>
                        <div className="flex-shrink-0">
                            <img src="/blog1.webp" alt="Getting Started with TypeScript" className="img-fluid rounded" style={{ width: '400px', height: '200px', objectFit: 'cover' }} />
                        </div>
                        <div className="flex-grow-1">
                            <header className="mb-3">
                                <h1 className="h2 text-start">Getting Started with TypeScript</h1>

                                <div className="text-muted">
                                    <span className="me-3">Pubished on: </span>
                                    <span>2024-01-15</span>
                                </div>
                            </header>
                            <div className="blog-content"></div>
                            <p className="lead">TypeScript is a powerful superset of JavaScript that adds static typing...asdkjsdafasdfads TypeScript is a powerful superset of JavaScript that adds static typing...asdkjsdafasdfads</p>
                            <Link to="/blogs/firstblog">Read more →</Link>
                        </div>
                    </div>
                </div>
            </div> */}

        </div>
    );
};

export default Blogs;